
      const mode = import.meta.env.MODE
      if ((mode !== 'pro' && mode !== 'dev') || sessionStorage.getItem('debug') == 1) {
        import('vconsole').then((VConsole) => {
          new VConsole.default()
        })
      }
    